import { render, staticRenderFns } from "./lazy_table_xy.vue?vue&type=template&id=f66fba6a&"
import script from "./lazy_table_xy.vue?vue&type=script&lang=js&"
export * from "./lazy_table_xy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports